import { render, staticRenderFns } from "./userAndLevelView.vue?vue&type=template&id=2f851fe6&"
import script from "./userAndLevelView.vue?vue&type=script&lang=js&"
export * from "./userAndLevelView.vue?vue&type=script&lang=js&"
import style0 from "./userAndLevelView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports